import React from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";
const _Input = (props) => {
  const {
    value,
    onChange,
    isError,
    errors,
    onBlur,
    rows = null,
    alias,
    name,
    id,
    placeholder = "",
    title,
    type = "text",
    required,
    pattern = null,
    onKeyPress = null,
    isDisabled = false,
    autoComplete = "on"
  } = props;

  return (
    <div className="flex flex-col py-2 w-full">
      <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
        {title}
        {required && <span className="text-red-700 mx-1">*</span>}
      </label>

      <Form.Control
        as={alias}
        name={name}
        id={id}
        required={required}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        placeholder={placeholder}
        isInvalid={isError}
        onKeyDown={onKeyPress}
        pattern={pattern}
        disabled={isDisabled}
        autoComplete={autoComplete}
      />
      <Form.Control.Feedback type="invalid">{errors}</Form.Control.Feedback>
    </div>
  );
};

_Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  errors: PropTypes.string,
  onBlur: PropTypes.func,
  rows: PropTypes.any,
  alias: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  onKeyPress: PropTypes.func,
  pattern: PropTypes.string,
  isDisabled: PropTypes.bool,
  autoComplete: PropTypes.string,
};

export default _Input;
